import _isString from 'lodash/isString';

export const constructPageTitle = title => {
  if (title && _isString(title)) {
    return `${title} | ORCA - Maritime Tools`;
  } else {
    return 'ORCA - Maritime Tools';
  }
};
